import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isByPass: false,
}

export const workspaceSlice = createSlice({
    name: 'workspaceSlice',
    initialState,
    reducers: {
        setIsByPass: (state, action) => {
            state.isByPass = action.payload
        },
    },
    extraReducers: () => {},
})

export default workspaceSlice.reducer

export const workspaceState = (state) => {
    const { workSpaceSlice } = state
    const { isByPass } = workSpaceSlice
    return {
        isByPass,
    }
}

export const { setIsByPass } = workspaceSlice.actions
